import { forwardRef, type SelectHTMLAttributes } from 'react'
import { cn } from '../lib/cn'
import { FieldShell, fieldDescribedBy, inputClass, useFieldId, type FieldChromeProps } from './field'

export type SelectProps = FieldChromeProps & Omit<SelectHTMLAttributes<HTMLSelectElement>, 'size'>

/** Labelled select: stable auto `id` + `htmlFor` (AUDIT_FIXES_JULY27 J1).
 * Options come through as children, exactly like a raw `<select>`. */
export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { label, hideLabel, help, error, size, wrapperClassName, id, className, required, children, ...rest },
  ref,
) {
  const fieldId = useFieldId(id)
  return (
    <FieldShell
      id={fieldId}
      label={label}
      hideLabel={hideLabel}
      help={help}
      error={error}
      required={required}
      wrapperClassName={wrapperClassName}
    >
      <select
        ref={ref}
        id={fieldId}
        required={required}
        aria-invalid={error ? true : undefined}
        aria-describedby={fieldDescribedBy(fieldId, help, error)}
        className={cn(inputClass(size), 'disabled:opacity-50', className)}
        {...rest}
      >
        {children}
      </select>
    </FieldShell>
  )
})
